<script>
    import { Meteor } from "meteor/meteor";

    let form = $state({
        firstName: "",
        middleName: "",
        lastName: "",
        dateOfBirth: "",
        phoneNumber: "",
        emailAddress: "",
        streetAddress: "",
        addressLine2: "",
        city: "",
        province: "",
        postalCode: "",
        employer: "",
        employerPhoneNumber: "",
        incomeType: "monthly",
        transactionType: "purchase",
        privacyConsent: false,
    });

    let result = $state({ submitting: false, success: "", error: "" });

    function submitApplication(event) {
        event.preventDefault();
        result = { submitting: true, success: "", error: "" };

        Meteor.call(
            "applications.submit",
            {
                payload: { ...form },
            },
            (error) => {
                if (error) {
                    result = {
                        submitting: false,
                        success: "",
                        error:
                            error.reason ||
                            "Application could not be submitted.",
                    };
                    return;
                }

                result = {
                    submitting: false,
                    success:
                        "Thank you for applying. We have received your application and will contact you soon.",
                    error: "",
                };
            },
        );
    }
</script>

<section>
    <h1>Financing Application</h1>
    <form class="application-form" onsubmit={submitApplication}>
        <div class="form-grid">
            <label
                >First Name*<input
                    required
                    bind:value={form.firstName}
                /></label
            >
            <label>Middle Name<input bind:value={form.middleName} /></label>
            <label
                >Last Name*<input required bind:value={form.lastName} /></label
            >
            <label
                >Date of Birth*<input
                    required
                    type="date"
                    bind:value={form.dateOfBirth}
                /></label
            >
            <label
                >Phone Number*<input
                    required
                    bind:value={form.phoneNumber}
                /></label
            >
            <label
                >Email Address*<input
                    required
                    type="email"
                    bind:value={form.emailAddress}
                /></label
            >
            <label
                >Street Address*<input
                    required
                    bind:value={form.streetAddress}
                /></label
            >
            <label>Address Line 2<input bind:value={form.addressLine2} /></label
            >
            <label>City*<input required bind:value={form.city} /></label>
            <label>Province*<input required bind:value={form.province} /></label
            >
            <label
                >Postal Code*<input
                    required
                    bind:value={form.postalCode}
                /></label
            >
            <label>Employer*<input required bind:value={form.employer} /></label
            >
            <label
                >Employer Phone Number*<input
                    required
                    bind:value={form.employerPhoneNumber}
                /></label
            >

            <fieldset>
                <legend>Income Type*</legend>
                <label
                    ><input
                        type="radio"
                        bind:group={form.incomeType}
                        value="monthly"
                    /> Monthly</label
                >
                <label
                    ><input
                        type="radio"
                        bind:group={form.incomeType}
                        value="bi-weekly"
                    /> Bi-weekly</label
                >
            </fieldset>

            <fieldset>
                <legend>Transaction Type*</legend>
                <label
                    ><input
                        type="radio"
                        bind:group={form.transactionType}
                        value="purchase"
                    /> Purchase</label
                >
                <label
                    ><input
                        type="radio"
                        bind:group={form.transactionType}
                        value="trade-in"
                    /> Trade-In</label
                >
            </fieldset>

            <label class="full consent">
                <input
                    type="checkbox"
                    required
                    bind:checked={form.privacyConsent}
                />
                I consent to VGO Auto Financing storing this application data and
                contacting me.
            </label>
        </div>

        <button type="submit" disabled={result.submitting}>
            {result.submitting ? "Submitting..." : "Submit Application"}
        </button>

        {#if result.error}<p class="error">{result.error}</p>{/if}
        {#if result.success}<p class="success">{result.success}</p>{/if}
    </form>
</section>
